module.exports = __webpack_public_path__ + "img/m3.86c8df60.png";